export default "__VITE_ASSET__H8u5XV5n__"